import { Link, useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import SupportTicketThread from "components/SupportTickets/SupportTicketThread";
import { partnerQueryKeys } from "../../api/queryKeys";
import { partnerTicketApi } from "../../api/endpoints/support";

/** One ticket's thread, where notifications about it land. */
const SupportTicketPage = () => {
  const { ticketId } = useParams();
  const queryClient = useQueryClient();

  return (
    <div>
      <Link
        to="/partner/help"
        className="mb-4 inline-block text-xs font-semibold text-teal-700 no-underline hover:text-teal-800"
      >
        ← Back to Help &amp; Support
      </Link>
      <SupportTicketThread
        ticketId={ticketId}
        api={partnerTicketApi}
        keyBase={partnerQueryKeys.support()}
        viewerSide="PARTNER"
        onRead={() => queryClient.invalidateQueries(partnerQueryKeys.supportUnread())}
      />
    </div>
  );
};

export default SupportTicketPage;
